module.exports = __webpack_public_path__ + "static/redot1-bc8fa08e44092a80111ffb71cc106ac9.gif";